
import React from "react";
import ViewNavbar from "./template/view.navbar";
import ViewHero from "./view.hero";
// import ViewStat from "./view.stat";
// import ViewDemo from "./view.demo";
import ViewFeature from "./view.feature";
import ViewSteps from "./view.steps";
import ViewPricing from "./view.pricing";
import ViewPatners from "./view.partners";
import { ViewCompany } from "./view.company";
import ViewContact from "./view.contact";
import ViewFooter from "./template/view.footer";


export default function Home() {


    return (
        <div>
            <ViewNavbar />
            <ViewHero />
            {/* <ViewStat /> */}
            {/* <ViewDemo /> */}
            <ViewFeature />
            <ViewSteps />
            <ViewPricing />
            <ViewPatners />
            <ViewCompany />
            <ViewContact />
            <ViewFooter />
        </div>
    )
}